import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BadgeSC } from './badge.styled';

export type BadgeTypes = 'PRIMARY' | 'SECONDARY' | string;

export type TBadgeSC = {
  type?: BadgeTypes;
  skipTranslation?: boolean;
};

type TProps = {
  text: string;
} & TBadgeSC;

const Badge: React.FC<TProps> = ({ text, skipTranslation, ...styleProps }) => {
  return (
    <BadgeSC {...styleProps}>{skipTranslation ? text : <FormattedMessage id={text} />}</BadgeSC>
  );
};

Badge.defaultProps = {
  type: 'SECONDARY',
};

export default Badge;
